import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

export default function DOETable({ timeSeries }) {
  return (
    <div
      className="border border-border rounded-[2px] overflow-x-auto bg-background"
      data-testid="doe-results-table"
    >
      <Table>
        <TableHeader>
          <TableRow className="bg-secondary/60 hover:bg-secondary/60">
            <TableHead className="text-[10px] uppercase tracking-[0.18em] font-semibold w-16">
              Step
            </TableHead>
            <TableHead className="text-[10px] uppercase tracking-[0.18em] font-semibold">
              Hour
            </TableHead>
            <TableHead className="text-[10px] uppercase tracking-[0.18em] font-semibold">
              Load scale
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold text-[var(--doe-import)]">
              Import (MW)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold text-[var(--doe-export)]">
              Export (MW)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              V<sub>min</sub> (p.u.)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              V<sub>max</sub> (p.u.)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              Max loading (%)
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {timeSeries.map((t) => (
            <TableRow
              key={t.time_step}
              className="font-mono text-xs"
              data-testid={`doe-row-${t.time_step}`}
            >
              <TableCell className="font-medium">{t.time_step}</TableCell>
              <TableCell>{String(t.hour).padStart(2, "0")}:00</TableCell>
              <TableCell>{t.scale.toFixed(2)}</TableCell>
              <TableCell className="text-right text-[var(--doe-import)] font-semibold">
                {t.total_import_mw.toFixed(2)}
              </TableCell>
              <TableCell className="text-right text-[var(--doe-export)] font-semibold">
                {t.total_export_mw.toFixed(2)}
              </TableCell>
              <TableCell className="text-right">
                {t.min_voltage != null ? t.min_voltage.toFixed(4) : "—"}
              </TableCell>
              <TableCell className="text-right">
                {t.max_voltage != null ? t.max_voltage.toFixed(4) : "—"}
              </TableCell>
              <TableCell className="text-right">
                {t.max_loading_percent != null ? t.max_loading_percent.toFixed(1) : "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
